var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",on:{"click":_vm.toggleTheme}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.theme == 'light'),expression:"theme == 'light'"}],staticClass:"icon icon-light"}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.theme == 'dark'),expression:"theme == 'dark'"}],staticClass:"icon icon-dark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }